module.exports = __webpack_public_path__ + "img/step.82f52448.png";